const STEPS = [
  { id: "scope-section", label: "Rate Scope" },
  { id: "origin-section", label: "Origin" },
  { id: "destination-section", label: "Destination" },
  { id: "basic-section", label: "Basic & Cargo" },
  { id: "charges-section", label: "Charges" },
];

const scrollToSection = (id) => {
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
};

// Clickable overview of the form's sections with live completion state —
// jumping straight to a section beats scrolling a long single-page form, and
// seeing "3/5 done" gives the KAM a sense of progress the plain stacked
// cards didn't.
const ProgressStepper = ({ completion }) => {
  const doneCount = STEPS.filter((s) => completion[s.id]).length;

  return (
    <div
      className="flex items-center gap-2 px-4 py-3 rounded-2xl overflow-x-auto oc-scroll"
      style={{ background: "#fff", border: "1px solid #EDEEF1", boxShadow: "0 1px 3px rgba(16,24,40,.05)" }}
    >
      <span className="text-xs font-bold text-gray-400 flex-none pr-1">
        {doneCount}/{STEPS.length}
      </span>
      {STEPS.map((s, i) => {
        const isDone = !!completion[s.id];
        return (
          <button
            key={s.id}
            type="button"
            onClick={() => scrollToSection(s.id)}
            className="flex items-center gap-1.5 flex-none px-3 py-1.5 rounded-full text-xs font-semibold transition-colors hover:opacity-80"
            style={{
              background: isDone ? "#EAF8F0" : "#F5F6F8",
              color: isDone ? "#12894F" : "#667085",
              border: isDone ? "1px solid #B7EBCB" : "1px solid #E7E9EC",
            }}
          >
            <span
              className="w-4 h-4 rounded-full flex items-center justify-center flex-none text-white"
              style={{ background: isDone ? "#12B76A" : "#B7BEC9", fontSize: 10 }}
            >
              {isDone ? "✓" : i + 1}
            </span>
            {s.label}
          </button>
        );
      })}
    </div>
  );
};

export default ProgressStepper;
